<template>
  <SendVerifyToken />
</template>

<script>
import SendVerifyToken from "../../components/login/sendVerifyToken";
export default {
  components: {
    SendVerifyToken,
  },
};
</script>
